import type { XingletInterface } from '../xinglet-helpers';
import { XingletWrapper } from '../xinglet-helpers';

import type { TemplateProps } from './';

export type TemplateCreativeProps = TemplateProps;
export type TemplateCreativeXinglet = XingletInterface<TemplateCreativeProps>;

export const Creative = XingletWrapper<TemplateCreativeProps>(
  `@xing-com/crate-lebenslauf-templates-creative`
);
